import React, { useState } from "react";

import Container from "@mui/material/Container";

import { makeStyles } from "@mui/styles";

import SearchOptions from "./SearchOptions";
import GameSessionsTable from "./Table";

const useStyles = makeStyles(() => ({}));

const GameSessions = () => {
  const classes = useStyles();

  return (
    <Container>
      <h2>Game Sessions</h2>
      <SearchOptions />
      <GameSessionsTable />
    </Container>
  );
};

export default GameSessions;
